<template>
  <v-dialog v-model="dialog" persistent max-width="700" scrollable>
    <v-card>
      <v-card-title>
        <span class="headline">Termos de Salvamento de Cartão</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="reject">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text v-if="loading" class="text-center py-8">
        <v-progress-circular
            indeterminate
            color="primary"
            size="50"
        ></v-progress-circular>
        <p class="mt-4">Carregando termos...</p>
      </v-card-text>

      <v-card-text v-else style="max-height: 400px;">
        <p class="update-date" v-if="termsLastUpdate">
          Última atualização: {{ formatDate(termsLastUpdate) }}
        </p>

        <div class="terms-content" v-html="termsContent"></div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="reject" class="btn-cancel">
          Recusar
        </v-btn>
        <v-btn
            color="success"
            class="btn-confirm"
            @click="accept"
            :loading="loading"
        >
          Aceitar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'CardSaveTermsDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      termsContent: '',
      termsLastUpdate: null
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.loadTerms();
      }
    }
  },
  methods: {
    async loadTerms() {
      this.loading = true;

      try {
        const { data } = await axios.get('/api/webdriver/landpage', {
          params: { tags: 'termos_de_uso_salvar_cartao' }
        });

        if (data && data.data && data.data.length > 0) {
          this.termsContent = data.data[0].content;
          this.termsLastUpdate = data.data[0].updated_at;
        }
      } catch (error) {
        this.$emit('error', 'Erro ao carregar termos. Tente novamente mais tarde.');
        this.reject();
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    accept() {
      this.$emit('accept');
      this.dialog = false;
    },
    reject() {
      this.$emit('reject');
      this.dialog = false;
    }
  }
};
</script>

<style scoped>
.headline {
  font-family: Roboto-Bold;
  color: #000;
}

.update-date {
  text-align: center;
  color: #666;
  font-size: 14px;
  margin-bottom: 20px;
}

.terms-content {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.terms-content >>> h1,
.terms-content >>> h2,
.terms-content >>> h3 {
  margin-top: 20px;
  margin-bottom: 10px;
  font-family: Roboto-Bold;
}

.terms-content >>> p {
  margin-bottom: 15px;
}

.btn-confirm,
.btn-cancel {
  text-transform: capitalize !important;
  font-family: Roboto-Bold !important;
  min-width: 100px;
}
</style>
